<template>

  <div v-title data-title="联系我们" class="warp warp_lianxi" v-if="data">
    <div class="modle_22">
      <div class="let" v-scroll-reveal>

        <img :src="data.img1" />
         <ChildBan></ChildBan>

      </div>
      <div class="cont">

        <div class="dm">

          <div class="t1" v-scroll-reveal>
            <img :src="data.img2" />
          </div>
          <div class="gr">
            <div class="it" v-scroll-reveal v-for="(item,index) in data.list" v-if="index < 4 ? true : false" :key="index">
              <div class="t2">
                {{item.title}}
              </div>
              <div class="t3" v-html="item.introduce"></div>
            </div>
          </div>

          <div class="im_gr cle">
            <div class="it" v-scroll-reveal v-for="(item,index) in data.list" v-if="index >= 4 ? true : false" :key="index">
              <div class="img">
                <img :src="item.img1" />
              </div>
              <div class="t2">
                {{item.title}}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    postcontactAPI
  } from '../../../api/api.js'
  import Head from '@/components/Head.vue'
  import ChildBan from '@/components/ChildBan.vue'

  export default {
    components: {
      Head,
      ChildBan
    },
    data() {
      return {
        sle_int: 0, //下表
        data: null, //
        data_list: null


      }
    },
    methods: {
      //获取案例信息
      getList() {
        var that = this;
        postcontactAPI().then(function(res) {
          that.data = res.data.data;

        }).catch(function(err) {
          console.log(err);
        })
      },


    },
    mounted() {
      this.getList();

    }

  }
</script>

<style lang="less" scoped>
  // 引入公共css3
  @import '../../assets/css3.css';

  .modle_22 {
    .let {
      position: fixed;
      height: 100%;
      width: 70%;
      left: 0px;
      top: 0px;

      img {
        width: 100%;
      }
    }

    .cont {
      position: fixed;
      right: 0px;
      width: 30%;
      top: 0px;
      height: 100%;
      overflow-y: scroll;

      .dm {
        padding: 100px;

        .t1 {
          margin-bottom: 80px;
          text-align: left;

        }

        .gr {
          .it {
            text-align: left;
            margin-bottom: 50px;

            .t2 {
              font-weight: bold;
              font-size: 25px;
              color: #000000;
              margin-bottom: 15px;
            }

            .t3 {
              line-height: 38px;
            }
          }
        }

        .im_gr {
          .it {
            float: left;
            margin-right: 25px;
            text-align: center;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/contact_us/contact_us.vue